import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  useBaseAsync,
  JuouProForm,
  JuouProFormItem,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'binduser',
  props: {
    clientId: {}
  },
  setup(__props: any, { expose: __expose }) {

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();

const visible = ref(false);

const props = __props;

const addInitValue = {

};
const conditionsInitValue = {
};

__expose({
  show: () => {
    visible.value = true;
  },
});


const init = useBaseAsync(async() => {
  const res = (await useApi().userApi.getAllUseruser());
  const options = res.data.data?.map((item: any) => ({
    value: item.id,
    label: item.username,
  }));

  columns.value = [
    {
      name: 'id',
      label: '用户名',
      type: 'searchSelect',
      options,
    },

  ];
});


const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    if (!props.clientId) {
      return {
        total: 0,
        data: [],
      };
    }
    loading.value = true;
    const res = await useApi().deviceApi.listDeviceUserdevice(props.clientId);
    const tableData: JuouProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data?.map((item: any) => ({ id: item })) || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});


const addFun = useBaseAsync(async(data: any) => {
  if (!props.clientId) {
    return;
  }
  await useApi().deviceApi.bindUserDevicedevice({
    clientId: props.clientId,
    userId: data.id,
  });
  ElMessage.success('绑定成功');
});


const deleteFun = useBaseAsync(async(data: any) => {
  if (!props.clientId) {
    return;
  }
  await useApi().deviceApi.unbindUserDevicedevice({
    clientId: props.clientId,
    userId: data.id,
  });
  ElMessage.success('解绑成功');
});


init();


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "设备绑定用户"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(JuouProTable), {
        ref_key: "tableRef",
        ref: tableRef,
        columns: columns.value,
        "get-data": _unref(getData),
        "on-add": _unref(addFun),
        "on-delete": _unref(deleteFun),
        "add-text": "绑定",
        "delete-text": "解绑",
        loading: loading.value,
        "row-key": "id",
        operates: operates,
        "add-init-values": addInitValue,
        "codition-init-values": conditionsInitValue
      }, null, 8, ["columns", "get-data", "on-add", "on-delete", "loading"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})